module.exports = __webpack_public_path__ + "img/souvenir3.55ee1a25.svg";